module.exports = __webpack_public_path__ + "media/audio21.f2199917.mp3";